
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter, matchPath } from 'react-router-dom'
import './AppBarSideNav.scss'
import techdocIcon from '../../images/icon_techdocs.svg'
import { connect } from 'react-redux'
import { Layout, Menu, Icon, Popover } from '@pan/cloud-base'
import _ from 'lodash'

const { Sider } = Layout
const { SubMenu } = Menu

const styles = {
  icon: {
    marginTop: '-1px',
    display: 'inline-block'
  }
}

const defaultOpenKeys = []
const defaultSelectedKeys = []

const NavBarItem = ({ navItem, index, depth, location, isCollapsed, className, subMenuClassName, ...other }) => {
  const [submenuPopoverVisible, setSubmenuPopoverVisible] = useState(false)

  const handleSubmenuPopoverVisibleChange = (visible) => {
    setSubmenuPopoverVisible(visible)
  }

  const handleSubmenuPopoverClick = (e) => {
    setSubmenuPopoverVisible(false)
  }

  if (navItem.defaultPath && !defaultSelectedKeys.includes(other.eventKey)) {
    defaultSelectedKeys.push(other.eventKey)
  }
  if (!navItem.subMenu) {
    return (
      <Menu.Item
        className={className}
        {...other}>
        <NavLink
          className='app-nav-link'
          to={{
            pathname: navItem.path,
            search: window.location.search
          }}
        >
          {navItem.icon &&
            <Icon>
              <img src={navItem.icon} className="left-nav-icon" style={styles.icon} alt={navItem.text} />
            </Icon>
          }
          <span>{navItem.text}</span>
        </NavLink>
      </Menu.Item>
    )
  }
  else {
    defaultOpenKeys.push(other.eventKey)
    return (
      <SubMenu
        title={
          <Popover
            placement="right"
            title=''
            content={SubMenuPopup(navItem, handleSubmenuPopoverClick)}
            trigger="click"
            overlayClassName='app-nav-menu-submenu-popover'
            visible={isCollapsed && submenuPopoverVisible}
            onVisibleChange={(e) => handleSubmenuPopoverVisibleChange(e)}
          >
            <span>
              {navItem.icon && <Icon className='app-submenu-icon'>
                <img src={navItem.icon} className="left-nav-icon" style={styles.icon} alt={navItem.text} />
              </Icon>}
              <span>{navItem.text}</span>
            </span>
          </Popover>
        }
        className={subMenuClassName}
        {...other}
      >
        { navItem.subMenu.map((childItem, i) => (
          <NavBarItem
            navItem={childItem}
            index={i}
            depth={depth + 1}
            key={childItem.path}
            location={location}
            subMenuClassName={subMenuClassName}
          />
        ))}
      </SubMenu>
    )
  }
}

const HelpSubMenu = (helpLink, handleHelpClick) => {
  if (_.isArray(helpLink)) {
    return (
      <ul style={{ padding: 0 }} onClick={handleHelpClick}>
        {helpLink.map((topic, index) => (
          <li key={index}
            className='app-nav-link'
          >
            <a href={topic.link}
              rel='noopener noreferrer'
              target='_blank'
            >{topic.name}</a>
          </li>
        ))}
      </ul>
    )
  }
  else {
    return <div></div>
  }
}



const SubMenuPopup = (navIem, handleSubmenuPopoverClick) => (
  <ul style={{ padding: 0 }}>
    {navIem.subMenu.filter(n => n.path).map((navItem, i) => (
      <NavLink
        className='app-nav-submenu-link app-nav-link'
        to={{
          pathname: navItem.path,
          search: window.location.search
        }}
        key={`${navIem.path}-${i}`}
        activeClassName='app-nav-submenu-popover-selected'
        style={{ padding: '15px', height: '40px' }}
        onClick={(e) => handleSubmenuPopoverClick(e)}
      >
        {navItem.icon &&
          <Icon>
            <img src={navItem.icon} className="left-nav-icon" style={styles.icon} alt={navItem.text} />
          </Icon>
        }
        <span>{navItem.text}</span>
      </NavLink>
    ))}
  </ul>
)

const AppBarSideNav = (props) => {
  const [helpPopoverVisible, setHelpPopoverVisible] = useState(false)
  const [selectedSubMenu, setSelectedSubMenu] = useState('')

  const handleHelpClick = (e) => {
    setHelpPopoverVisible(false)
  }

  const handleHelpVisibleChange = (visible) => {
    setHelpPopoverVisible(visible)
  }


  const onMenuSelect = ({ keyPath }) => {
    setSelectedSubMenu('')
    const parentPath = getParentSubMenu(...keyPath)
    if (parentPath) {
      setSelectedSubMenu(parentPath)
    }
  }

  const getSelectedKeys = (path) => {
    const matchRoute = _.find(props.navItems, (route) => (route.path && matchPath(path, route)))
    if (matchRoute?.hideSidebarNav) {
      const selectedKey = `/${matchRoute.path.split('/')[1]}`
      return selectedKey
    }
    return path
  }

  const getParentSubMenu = (keyPath) => {
    const route = props.navItems.find(navItem => navItem.path === keyPath)
    if (route) {
      return null
    }

    let parentPath = null
    for (const route of props.navItems) {
      if (route.subMenu) {
        const subRoute = route.subMenu.find(navItem => navItem.path === keyPath)
        if (subRoute) {
          parentPath = route.path
          break
        }
      }
    }
    return parentPath
  }

  if (props.navItems.length > 0) {
    if (!selectedSubMenu) {
      const parentPath = getParentSubMenu(props.location?.pathname)
      if (parentPath) {
        setSelectedSubMenu(parentPath)
      }
    }

    return (
      <Layout>
        <Sider className='app-nav-bar-slider' trigger={null} collapsible collapsed={props.isAppBarSideCollapsed}>
          <Menu
            mode='inline'
            inlineCollapsed={props.isAppBarSideCollapsed}
            defaultOpenKeys={defaultOpenKeys}
            defaultSelectedKeys={defaultSelectedKeys}
            selectedKeys={[getSelectedKeys(props.location?.pathname)]}
            className='app-nav-upper-menu'
            onSelect={onMenuSelect}
          >
            {props.navItems.filter(n => n.path).map((navItem, i) => (
              !navItem.hideSidebarNav && <NavBarItem
                navItem={navItem}
                index={i} depth={1}
                isCollapsed={props.isAppBarSideCollapsed}
                key={navItem.path}
                className='app-nav-menu-item'
                location={props.location}
                subMenuClassName={props.isAppBarSideCollapsed && selectedSubMenu === navItem.path ? 'app-nav-submenu-selected' : 'app-nav-submenu'}
              >
              </NavBarItem>
            ))}
            {props?.helpLink && <Menu.Item key={ 'help' } style={{ width: '100%', marginTop: 'auto' }} className='app-nav-link'>
              <Popover
                placement="right"
                title={'TECHDOCS'}
                content={HelpSubMenu(props?.helpLink, handleHelpClick)}
                trigger="click"
                visible={helpPopoverVisible}
                onVisibleChange={(e) => handleHelpVisibleChange(e)}
                overlayClassName={props.isAppBarSideCollapsed ? 'app-nav-menu-popover-collapsed' : 'app-nav-menu-popover'}
              >
                <Icon>
                  <img src={techdocIcon} style={styles.icon} alt='TECHDOCS' />
                </Icon>
                <span>TechDocs</span>
              </Popover>
            </Menu.Item>}
          </Menu>
        </Sider>
      </Layout>
    )
  }
  return null
}

AppBarSideNav.propTypes = {
  navItems: PropTypes.array,
  helpLink: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  onLogout: PropTypes.func,
  userName: PropTypes.string,
  companyName: PropTypes.string,
  email: PropTypes.string,
  selectedAccount: PropTypes.object,
  location: PropTypes.object,
  isAppBarSideCollapsed: PropTypes.bool,
}

AppBarSideNav.defaultProps = {
  navItems: [],
  helpLink: [],
}

NavBarItem.propTypes = {
  navItem: PropTypes.object,
  index: PropTypes.number,
  depth: PropTypes.number,
  location: PropTypes.object,
  isCollapsed: PropTypes.bool,
  className: PropTypes.string,
  subMenuClassName: PropTypes.string,
}

const mapStateToProps = ({ isAppBarSideCollapsed }) => ({ isAppBarSideCollapsed })

export default withRouter(connect(mapStateToProps)(AppBarSideNav))
